import { createContext } from "react";
import { EntityAuthField } from "src/services/link/queries/NetTypes";
import { AppThemeType, ConnectedEntity } from "src/types/apps";

export type CustomConnectProps = {
	theme?: AppThemeType;
	themeType: string;
	updateToken?: string;
	externalId?: string;
	restoreToken?: string;
	onConnect: (token: string, redirectUri: string) => void;
	showSaveCheckbox?: boolean;
};

export interface ContextType {
	customConnectProps?: CustomConnectProps;
	entity?: ConnectedEntity;
	params: EntityAuthField[];
	id: string;
	product?: string;
	selectedValue: string;
	onChangeValue: (value: string) => void;
}

const defaultContextValues: ContextType = {
	params: [],
	id: "",
	selectedValue: "",
	onChangeValue: () => {}
};

export default createContext<ContextType>(defaultContextValues);
